import { createSelector, createSlice } from "@reduxjs/toolkit"
import { statesService } from "../../services/admin/states"
import { mapToSelectNamesOptions } from "../../../shared/parsers/options"

const initialState = {
  list: [],
  options: [],
}

const statesSlice = createSlice({
  name: "states",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addMatcher(statesService.endpoints.getStates.matchFulfilled, (state, action) => {
      if (action.payload) {
        if (action.payload && Array.isArray(action.payload)) {
          state.options = mapToSelectNamesOptions(action.payload)
        }
      }
    })
  },
})

const selectStatesState = (state) => state.states

export const {} = statesSlice.actions

export const selectstates = createSelector([selectStatesState], (state) => state.states)

export const selectstatesOptions = createSelector([selectStatesState], (state) => state.options)

export default statesSlice.reducer
